import { render, staticRenderFns } from "./SkillsStudent.vue?vue&type=template&id=c109d704&scoped=true"
import script from "./SkillsStudent.vue?vue&type=script&lang=js"
export * from "./SkillsStudent.vue?vue&type=script&lang=js"
import style0 from "./SkillsStudent.vue?vue&type=style&index=0&id=c109d704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c109d704",
  null
  
)

export default component.exports